import React,{ useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import LoadingSpinner from "../../Loading/component";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import moment from "moment-timezone";
import awaitingIcon from "../../../assests/awaitingIcon.svg";
import search from "../../../assests/search.svg";
import combodetailsIcon from "../../../assests/combodetailsIcon.svg";
import emotions7 from "../../../assests/emotions7.svg";
import remove from "../../../assests/remove.svg";

export const ComboDetailsComponent = (props) => {
  const { comboId } = useParams();
  const [machineSearchQuery, setMachineSearchQuery] = useState("");
  const [showVMModal, setShowVMModal] = useState(false);
  const [selectedVMIDs, setSelectedVMIDs] = useState([]);

  const handleSeeMore = (vmIDs) => {
    setSelectedVMIDs(vmIDs);
    setShowVMModal(true);
  };

  const handleCloseModal = () => {
    setShowVMModal(false);
    setSelectedVMIDs([]);
  };
  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  const handleSearchChange = (e) => {
    setMachineSearchQuery(e.target.value);
  };

  const filteredCohorts = props.comboDetailsData?.combo_cohorts?.filter(
    (machine) => {
      const cohortIdString = String(machine?.cohort_id || "");
      const searchQueryString = String(machineSearchQuery || "");

      return searchQueryString
        ? cohortIdString.includes(searchQueryString)
        : true;
    }
  );

  const handleAddCohortCombo = () => {
    navigate(`/home/comboupdatecohort/${comboId}`);
  };
  const handleUpdateComboDetails = () => {
    navigate(`/home/comboupdatedetails/${comboId}`);
  };

  return (
    <div className="main-div" style={{ margin: "auto" }}>
      <div>
        <Sidebar />
      </div>

      {props.loading ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <>
          <div
            style={{
              margin: "auto",
              overflow: "auto",
              height: "100vh",
              width: "90vw",
            }}
          >
            <div>
              <div>
                <h2 style={{ width: "16vw", margin: "8px" }}>
                  <img
                    onClick={arrowClick}
                    style={{ width: "22px", cursor: "pointer" }}
                    src={leftArrow}
                    alt=""
                  />{" "}
                  Combo ID {props.comboDetailsData && props.comboDetailsData.id}
                </h2>
              </div>

              <div className="combo-details-container">
                <div className="combo-header">
                  <h3 className="combo-title">
                    <span role="img" aria-label="combo-icon">
                      <img
                        src={combodetailsIcon}
                        alt=""
                        style={{ marginRight: "10px" }}
                      />
                    </span>{" "}
                    Combo Details
                  </h3>
                  <button
                    className="edit-button"
                    onClick={() => handleUpdateComboDetails(comboId)}
                  >
                    Edit
                  </button>
                </div>
                <div>
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: "18px",
                      fontFamily: "Poppins",
                    }}
                  >
                    {props.comboDetailsData && props.comboDetailsData.name}
                  </h3>
                  <p className="combo-description">
                    <strong
                      style={{
                        fontWeight: 600,
                        fontSize: "18px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Description:
                    </strong>{" "}
                    {props.comboDetailsData &&
                      props.comboDetailsData.description}
                  </p>
                </div>

                <div className="combo-main">
                  <div className="combo-left">
                    <div className="combo-image">
                      <img
                        src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${
                          props.comboDetailsData &&
                          props.comboDetailsData.image_url
                        }`}
                        alt="Combo"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>

                    <p style={{ marginTop: "20px" }}>
                      <strong>Apply on:</strong>{" "}
                      {props.comboDetailsData &&
                      props.comboDetailsData.kiosk_app_enabled &&
                      props.comboDetailsData &&
                      props.comboDetailsData.consumer_app_enabled
                        ? "Kiosk and Consumer App"
                        : props.comboDetailsData &&
                          props.comboDetailsData.kiosk_app_enabled
                        ? "Kiosk"
                        : props.comboDetailsData &&
                          props.comboDetailsData.consumer_app_enabled
                        ? "Consumer App"
                        : "Not available"}
                    </p>
                  </div>

                  <div className="combo-right">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-around",
                        gap: "20px",
                      }}
                    >
                      <div className="price-box">
                        <p>
                          <strong>Actual Price:</strong> ₹{" "}
                          {props.comboDetailsData &&
                            props.comboDetailsData.actual_price}{" "}
                        </p>
                        <p>
                          <strong>Selling Price:</strong> ₹{" "}
                          {props.comboDetailsData &&
                            props.comboDetailsData.total_price}{" "}
                        </p>
                      </div>
                      <div className="date-box">
                        <p>
                          <strong>Active Date:</strong>{" "}
                          {moment
                            .utc(
                              props.comboDetailsData &&
                                props.comboDetailsData.activates_at
                            )
                            .tz("Asia/Kolkata")
                            .format("YYYY-MM-DD")}{" "}
                        </p>
                        <p className="expire-date">
                          <strong>Expire Date:</strong>{" "}
                          {moment
                            .utc(
                              props.comboDetailsData &&
                                props.comboDetailsData.expires_at
                            )
                            .tz("Asia/Kolkata")
                            .format("YYYY-MM-DD")}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="mvid-table">
                      <table style={{ display: "block" }}>
                        <thead>
                          <tr>
                            <th>MVID</th>
                            <th>Quantity</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody
                          style={{
                            display: "block",
                            overflowY:
                              props.comboDetailsData &&
                              props.comboDetailsData.mv_config &&
                              props.comboDetailsData.mv_config.length > 3
                                ? "scroll"
                                : "visible",
                            height:
                              props.comboDetailsData &&
                              props.comboDetailsData.mv_config &&
                              props.comboDetailsData.mv_config.length > 3
                                ? "120px"
                                : "auto",
                                
                          }}
                        >
                          {props.comboDetailsData &&
                            props.comboDetailsData.mv_config &&
                            props.comboDetailsData.mv_config.length > 0 &&
                            props.comboDetailsData.mv_config.map((item) => (
                              <tr key={item.mv_id}>
                                <td>{item.mv_id}</td>
                                <td>{item.quantity}</td>
                                <td>{item.price}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="combo-details-container"
              style={{ margin: "40px 46px" }}
            >
              <div className="combo-header">
                <h3 className="combo-title">
                  <span role="img" aria-label="combo-icon">
                    <img
                      src={combodetailsIcon}
                      alt=""
                      style={{ marginRight: "10px" }}
                    />
                  </span>{" "}
                  Combo Mapping
                </h3>
                <div className="cohort-buttons">
                  {props.comboDetailsData &&
                  props.comboDetailsData.combo_cohorts.length > 0 ? (
                    <>
                      <button
                        className="edit-button"
                        onClick={props.handleRemoveClick}
                      >
                        Remove
                      </button>
                      <button
                        className="edit-button"
                        onClick={() => handleAddCohortCombo(comboId)}
                      >
                        Add
                      </button>
                    </>
                  ) : (
                    <button
                      className="edit-button"
                      onClick={() => handleAddCohortCombo(comboId)}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>

              {props.comboDetailsData &&
              props.comboDetailsData.combo_cohorts.length > 0 ? (
                <>
                  <div>
                    <div
                      style={{
                        padding: "12px",
                        position: "relative",
                        width: "20vw",
                        border: "none",
                      }}
                    >
                      <input
                        type="search"
                        value={machineSearchQuery}
                        onChange={handleSearchChange}
                        style={{
                          borderRadius: "12px",
                          padding: "10px 40px 10px 18px",
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                        placeholder="Search by cohort ID "
                      />
                      <img
                        src={search}
                        alt="search"
                        style={{
                          position: "absolute",
                          right: "18px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    <div style={{ height: "40vh", overflowY: "scroll" }}>
                      <Table striped hover style={{ backgroundColor: "#fff" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "100px" }}></th>
                            <th style={{ width: "100px" }}>Cohort ID</th>
                            <th>V.M ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCohorts?.length > 0 ? (
                            filteredCohorts.map((item) => (
                              <tr key={item.cohort_id}>
                                <td style={{ width: "120px" }}>
                                  {props.showTableForRemoval && (
                                    <img
                                      src={remove}
                                      alt=""
                                      onClick={() =>
                                        props.handleConfirmRemove(
                                          item.cohort_id
                                        )
                                      }
                                      style={{
                                        marginRight: "30px",
                                        textAlign: "left",
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    width: "120px",
                                  }}
                                >
                                  {item.cohort_id}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.vm_ids.slice(0, 20).join(", ")}
                                  {item.vm_ids.length > 20 && (
                                    <>
                                      ...{" "}
                                      <p
                                        onClick={() =>
                                          handleSeeMore(item.vm_ids)
                                        }
                                      >
                                        See More
                                      </p>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <div
                              style={{
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <p>No cohorts found</p>
                            </div>
                          )}
                        </tbody>
                      </Table>

                      <Modal show={showVMModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                          <Modal.Title>VM IDs</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>{selectedVMIDs.join(", ")}</p>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={handleCloseModal}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      {props.showTableForRemoval && (
                        <button
                          className="cancel-button"
                          onClick={props.handleCancelRemove}
                        >
                          Cancel
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="noResultcombo">
                  <div className="combodetailsimage">
                    <img src={emotions7} alt="" />
                    <p> No combos found</p>
                  </div>
                </div>
              )}

              <Modal
                show={props.showConfirmModal}
                onHide={() => props.setShowConfirmModal(false)}
              >
                <Modal.Body
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={awaitingIcon}
                    alt=""
                    style={{ height: "120px", width: "100px" }}
                  />
                  <p style={{ color: "#E02D3C", fontWeight: 600 }}>
                    Are you sure you want to remove it?
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      margin: "auto",
                      gap: "60px",
                    }}
                  >
                    <Button
                      style={{
                        color: "#14AE78",
                        borderColor: "#14AE78",
                        fontSize: "12px",
                        padding: "10px 24px",
                      }}
                      variant="outlined"
                      onClick={() => props.setShowConfirmModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{
                        color: "#14AE78",
                        borderColor: "#14AE78",
                        fontSize: "12px",
                        padding: "10px 24px",
                      }}
                      variant="outlined"
                      onClick={props.confirmRemove}
                    >
                      Confirm
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
